import { FormattedDate } from "@swa-ui/core";

import { withFormField } from "../withFormField";

/**
 * FormattedDateFormField provides support for a standard FormattedDate component to be used in a Form.
 */

export const FormattedDateFormField = withFormField(FormattedDate);
